import storeSelect from './storeSelect.vue';

export default storeSelect;
